<!-- 有修正要檢查同步改到 jkaggrid.component.html -->

<div class="w-full">
  <ag-grid-angular #myGrid [theme]="gridSrv.theme" [columnDefs]="columnDefs" [columnTypes]="gridSrv.columnTypes"
    [defaultColDef]="defaultColDef" [localeText]="gridSrv.localeText" [pagination]="gridSrv.pagination"
    [paginationPageSize]="gridSrv.paginationPageSize" [paginationPageSizeSelector]="gridSrv.paginationPageSizeSelector"
    [rowSelection]="gridSrv.rowSelection" (gridReady)="onGridReady($event)" (keydown)="onKeydown($event)"
    [editType]="'fullRow'" [enableBrowserTooltips]="true" (cellValueChanged)="onCellValueChanged($event)"
    (rowSelected)="onRowSelected($event)" (onSelectionChanged)="onSelectionChanged()">
  </ag-grid-angular>

</div>
